import { catchError, from, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { CONSENT_APPROVAL_PATH } from './consent-approval.config';

@Injectable()
export class ConsentApprovalErrorInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly commands = inject(CONSENT_APPROVAL_PATH);

  public intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(httpRequest)
      .pipe(catchError((err: HttpErrorResponse) => {
        if (err.status === 451) {
          from(this.router.navigate(this.commands, { skipLocationChange: true }));
        }
        return throwError(() => err);
      }));
  }
}
